const RolePermission = {

    // FIELDS
    "role": "Role",
    "permission": "Permission",

    // PAGE HEADER
    "assign_permission": "Assign Permission",

    // ERROR
    "error_role": "Select Role",
    "error_permission": "Check at Least One Permission",

}

export default RolePermission;